// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"50dc9c35","453":"b44ce015","455":"ad1f6e8e","977":"76e6e77a"}[chunkId] + ".chunk.js";
};